import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { ITag } from '../../../../../interfaces/graph-types';
import { AccountService } from '../../../../../services/account.service';
import { WatchAccountService } from '../../../../../services/watch-account.service';

@Component({
  selector: 'tag-element-component',
  template: require('./tag-element.component.pug'),
  styles: [require('./tag-element.component.css').toString()],
})
export class TagElementComponent implements OnInit {
  @Input()
  tag: ITag;

  editMode = false;
  isUpdating = false;
  errorMessage?: string;
  updateNameForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private watch: WatchAccountService,
  ) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.updateNameForm = this.formBuilder.group({
      name: this.tag.name,
    });
  }

  // -------------------------------------------------------------------
  onEditClick() {
    this.editMode = true;
  }

  // -------------------------------------------------------------------
  onCancelClick() {
    this.cancel();
  }

  // -------------------------------------------------------------------
  onNameInputKeyUp(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.cancel();
    }
  }

  // -------------------------------------------------------------------
  cancel() {
    this.editMode = false;
    this.errorMessage = undefined;
    this.updateNameForm.controls.name.setValue(this.tag.name);
  }

  // -------------------------------------------------------------------
  onDelete(_data, onSuccess: onSmartSuccess, onFailure: onSmartFailure) {
    this.accountService.deleteTag(
      this.watch.accountId().getValue(),
      this.tag.id,
      () => {
        // onSuccess(); we'll reload the page, leave the spinner
      },
      error => {
        onFailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  onSubmit({ name }: { name: string }) {
    if (name === this.tag.name) {
      this.editMode = false;
      return;
    }

    this.isUpdating = true;
    this.accountService
      .setCandidateTagField({
        accountId: this.watch.accountId().getValue(),
        tagId: this.tag.id,
        fieldName: 'name',
        value: name,
      })
      .subscribe(
        () => {
          this.isUpdating = false;
        },
        error => {
          this.errorMessage = error;
          this.isUpdating = false;
        },
      );
  }
}
